import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

/**
 * Renders the same markup as angular2-toaster, which _toaster.scss and the Cypress specs rely on.
 */
@Component({
  // Attribute selector, so ngx-toastr creates a <div> host (_toaster.scss styles `.toast-container > div`).
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[agrToasterToast]',
  template: `
    <div class="toast-content">
      <div class="toast-title">{{ title }}</div>
      <div class="toast-message">
        <div>{{ message }}</div>
      </div>
    </div>
  `,
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
      transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])
  ]
})
export class ToasterToastComponent extends Toast {}
